import gql from 'graphql-tag';

/**
 * Reusable fragments
 */
export const ClaimItemsFields = gql`
  fragment ClaimItemsFields on ClaimItemsOutput {
    sanityId
    name
    amountCents
    quantity
    discountCents
    subtotalCents
    taxCents
    type
  }
`;

export const CustomerFields = gql`
  fragment CustomerFields on GSTCustomerOutput {
    id
    email
    name
    phoneNumber
  }
`;

export const SuggestedOutcomeFields = gql`
  fragment SuggestedOutcomeFields on SuggestedOutcome {
    decision
    remediationMethodTypes
    warnings
    refundAward {
      amountCents
    }
    pointsAward {
      points
    }
    couponAward {
      templateId
      loyaltyEngineId
      couponValueCents
    }
  }
`;

export const ClaimViewFields = gql`
  fragment ClaimViewFields on ClaimView {
    claimId
    region
    orderId
    orderChannel
    status
    remediationReason
    refundedAmountCents
    createdAt
    updatedAt
    agentToIssueClaim {
      id
      email
    }
    agentToProcessClaim {
      id
      email
    }
    remediationOffered {
      ...SuggestedOutcomeFields
    }
    remediationAwarded {
      method
      amountCents
      points
      templateId
      loyaltyEngineId
      couponValueCents
    }
    customer {
      ...CustomerFields
    }
    items {
      ...ClaimItemsFields
    }
  }
  ${SuggestedOutcomeFields}
  ${CustomerFields}
  ${ClaimItemsFields}
`;
